export default {
  APP_VERSION: '1.0.0',

  // AUTH
  URL_LOGIN: '/auth/login',
  URL_VALIDATE_AUTH_TOKEN: '/auth/token',
  URL_PASSWORD_RESET: '/auth/reset/:modelType',
  URL_PASSWORD_RESET_CONFIRM: '/auth/reset/confirm/:modelType',
  URL_PASSWORD_CHANGE: '/auth/changePassword/:modelType',

  // CLIENTS
  URL_GET_ALL_CLIENT: '/client?trainer_id=:trainerID',
  URL_CREATE_CLIENT: '/client?trainer_id=:trainerID',
  URL_UPDATE_CLIENT: '/client/:clientID?trainer_id=:trainerID',
  URL_INVITE_CLIENT: '/client/:clientID/invite?trainer_id=:trainerID',
  URL_RESEND_INVITE_CLIENT:
    '/client/:clientID/resend-invite?trainer_id=:trainerID',
  URL_GET_CLIENT: '/client/:clientID?trainer_id=:trainerID',
  URL_ARCHIVE_ClIENT: '/client/:clientID/archive',

  // CLIENT PROGRAM
  URL_GET_ALL_CLIENT_PROGRAM:
    '/program/:programID/weekRange?weekNumberGte=:FROM&weekNumberLte=:TO&today=:TODAY',
  URL_GET_CLIENT_PROGRAM:
    '/program/:programID?org_id=:orgID&trainer_id=:trainerID&user_id=:userID',

  URL_OVERRIDE_CLIENT_PROGRAM: '/program/:programID/duplicate',

  // PROGRAM GENERAL
  URL_GET_PROGRAM:
    '/program/:programID?org_id=:orgID&trainer_id=:trainerID&user_id=:userID',
  URL_UPDATE_PROGRAM:
    '/program/:programID?org_id=:orgID&trainer_id=:trainerID&user_id=:userID',
  URL_ADD_UPDATE_WORKOUT_DAY: '/program/:programID/day/workout',
  URL_ADD_UPDATE_TRAINER_NOTE: '/program/:programID/day/trainerNote',
  URL_DELETE_TRAINER_NOTE:
    '/program/:programID/week/:weekID/day/:dayID/trainerNote',
  URL_ADD_CHECKIN_DAY: '/program/:programID/day/checkIn',
  URL_DELETE_CHECKIN_DAY:
    '/program/:programID/week/:weekID/day/:dayID/checkIn/:checkinID',
  URL_DELETE_WORKOUT_DAY:
    '/program/:programID/week/:weekID/day/:dayID/workout/:workoutID',
  URL_DELETE_CUSTOM_WORKOUT_DAY:
    '/program/:programID/week/:weekID/day/:dayID/customWorkout',
  URL_GET_ALL_DAY:
    '/program/day/:dayID?org_id=:orgID&trainer_id=:trainerID&user_id=:userID',
  URL_UPDATE_PROGRAM_DAY:
    '/program/day/:dayID?org_id=:orgID&trainer_id=:trainerID&user_id=:userID&updateWeek=true',
  URL_DUPLICATE_DAY: '/program/:programID/day/duplicate',
  URL_DUPLICATE_WEEK: '/program/:programID/week/duplicate',
  URL_CLEAR_ALL_DAY_EVENTS:
    '/program/:programID/week/:weekID/day/:dayID/allEvents',
  URL_CLEAR_ALL_WEEK_EVENTS: '/program/:programID/week/:weekID/allEvents',
  URL_CLEAR_ALL_PROGRAM: '/program/:programID/allEvents',

  URL_GET_CLIENT_ACTIVITY:
    '/trainer/:trainerID/client/:userID/activity?monday=:monday',

  URL_GET_PROGRAM_SHAPE:
    '/program/shape?org_id=:orgID&trainer_id=:trainerID&user_id=:userID',

  URL_CREATE_NEW_PROGRAM:
    '/program/?org_id=:orgID&trainer_id=:trainerID&user_id=:userID',

  URL_DUPLICATE_PROGRAM: '/program/:programID/clone',

  URL_DELETE_PROGRAM:
    '/program/:programID?org_id=:orgID&trainer_id=:trainerID&user_id=:userID',

  URL_GET_ALL_PROGRAM:
    '/program/?org_id=:orgID&trainer_id=:trainerID&user_id=:userID',

  URL_GET_PROGRAM_RANGE:
    '/program/:programID/weekRange?weekNumberGte=:FROM&weekNumberLte=:TO',
  URL_GET_PROGRAM_WEEKS:
    '/program/week?org_id=:orgID&trainer_id=:trainerID&user_id=:userID',

  // CIRCUIT
  URL_GET_CIRCUIT_SHAPE:
    '/circuit/shape?trainer_id=:trainerID&org_id=:orgID&user_id=:userID',
  URL_GET_ALL_CIRCUITS:
    '/circuit?trainer_id=:trainerID&org_id=:orgID&user_id=:userID',
  URL_GET_CIRCUIT:
    '/circuit/:circuitID?trainer_id=:trainerID&org_id=:orgID&user_id=:userID',
  URL_CREATE_CIRCUIT:
    '/circuit?trainer_id=:trainerID&org_id=:orgID&user_id=:userID',
  URL_UPDATE_CIRCUIT:
    '/circuit/:circuitID?trainer_id=:trainerID&org_id=:orgID&user_id=:userID',
  URL_DELETE_CIRCUIT:
    '/circuit/:circuitID?trainer_id=:trainerID&org_id=:orgID&user_id=:userID',

  // EQUIPMENT
  URL_GET_EQUIPMENT_SHAPE:
    '/equipment/shape?trainer_id=:trainerID&org_id=:orgID&user_id=:userID',
  URL_GET_ALL_EQUIPMENT: '/equipment?trainer_id=:trainerID&org_id=:orgID',
  URL_GET_EQUIPMENT:
    '/equipment/:equipmentID?trainer_id=:trainerID&org_id=:orgID',
  URL_CREATE_EQUIPMENT:
    '/equipment?trainer_id=:trainerID&org_id=:orgID&user_id=:userID',
  URL_UPDATE_EQUIPMENT:
    '/equipment/:equipmentID?trainer_id=:trainerID&org_id=:orgID&user_id=:userID',
  URL_DELETE_EQUIPMENT:
    '/equipment/:equipmentID?trainer_id=:trainerID&org_id=:orgID&user_id=:userID',

  // EQUIPMENT_TYPE
  URL_GET_ALL_EQUIPMENT_TYPES:
    '/equipmentType?trainer_id=:trainerID&org_id=:orgID',
  URL_GET_EQUIPMENT_TYPE:
    '/equipmentType/:equipmentTypeID?trainer_id=:trainerID&org_id=:orgID&user_id=:userID',
  URL_CREATE_EQUIPMENT_TYPE:
    '/equipmentType?trainer_id=:trainerID&org_id=:orgID&user_id=:userID',
  URL_UPDATE_EQUIPMENT_TYPE:
    '/equipmentType/:equipmentTypeID?trainer_id=:trainerID&org_id=:orgID&user_id=:userID',
  URL_DELETE_EQUIPMENT_TYPE:
    '/equipmentType/:equipmentTypeID?trainer_id=:trainerID&org_id=:orgID&user_id=:userID',

  // EXERCISE
  URL_GET_EXERCISE_SHAPE: '/exercise/shape?trainer_id=:trainerID&org_id=:orgID',
  URL_GET_ALL_EXERCISE: '/exercise?org_id=:orgID',
  URL_GET_EXERCISE: '/exercise/:exerciseID?trainer_id=:trainerID&org_id=:orgID',
  URL_CREATE_EXERCISE: '/exercise?trainer_id=:trainerID&org_id=:orgID',
  URL_UPDATE_EXERCISE:
    '/exercise/:exerciseID?trainer_id=:trainerID&org_id=:orgID',
  URL_DELETE_EXERCISE:
    '/exercise/:exerciseID?trainer_id=:trainerID&org_id=:orgID',

  // EXERCISE_DIFFICULTY
  URL_GET_ALL_EXERCISE_DIFFICULTY:
    '/exerciseDifficulty?trainer_id=:trainerID&org_id=:orgID',
  URL_GET_EXERCISE_DIFFICULTY:
    '/exerciseDifficulty/:exerciseDifficultyID?trainer_id=:trainerID&org_id=:orgID',
  URL_CREATE_EXERCISE_DIFFICULTY: '/exerciseDifficulty?trainer_id=:trainerID',
  URL_UPDATE_EXERCISE_DIFFICULTY:
    '/exerciseDifficulty/:exerciseDifficultyID?trainer_id=:trainerID',
  URL_DELETE_EXERCISE_DIFFICULTY:
    '/exerciseDifficulty/:exerciseDifficultyID?trainer_id=:trainerID&org_id=:orgID',

  // LEARN
  URL_GET_LEARN_COHORTS: '/learn',
  URL_ENROLL_TRAINER_IN_COHORT: '/learn/:cohortId/enroll',
  URL_TRACK_COHORT_WATCH: '/learn/:cohortId/:moduleSlug/track',

  // MUSCLE_GROUP
  URL_GET_ALL_MUSCLE_GROUP: '/muscleGroup?trainer_id=:trainerID&org_id=:orgID',
  URL_GET_MUSCLE_GROUP:
    '/muscleGroup/:muscleGroupID?trainer_id=:trainerID&org_id=:orgID',
  URL_CREATE_MUSCLE_GROUP: '/muscleGroup?trainer_id=:trainerID',
  URL_UPDATE_MUSCLE_GROUP: '/muscleGroup/:muscleGroupID?trainer_id=:trainerID',
  URL_DELETE_MUSCLE_GROUP:
    '/muscleGroup/:muscleGroupID?trainer_id=:trainerID&org_id=:orgID',

  // NUTRITION EXTRAS
  URL_GET_NUTRITION_DIET_OPTS: '/nutritionExtras/manageDiets',
  URL_GET_NUTRITION_HEALTH_OPTS: '/nutritionExtras/manageHealths',
  URL_GET_NUTRITION_TAGS: '/nutritionExtras/manageTags',
  URL_GET_AUTOCOMPLETE_LISTS: '/nutritionExtras/autoCompleteLists',
  URL_GET_RECIPE_IMAGE_UPLOAD_URL: `/nutritionExtras/images/sign`,
  URL_CREATE_NUTRITION_TAG: '/nutritionExtras/tag/add',
  URL_UPDATE_NUTRITION_TAG: '/nutritionExtras/tag/:tagID/update',
  URL_DELETE_NUTRITION_TAG: '/nutritionExtras/tag/:tagID/delete',

  // ORG
  URL_GET_ORG: '/org/:orgID',
  URL_GET_ORG_S3_UPLOAD_ENDPOINT:
    '/org/:orgID/signedUrl?requestType=:requestType&trainerId=:trainerID',

  // PLATELIST
  URL_GET_ALL_PLATELISTS: '/platelist/platelistDiscovery',
  URL_GET_PLATELIST: '/platelist/:platelistId/payload',
  URL_GET_PLAN_GRID: '/platelist/findOrCreate',
  URL_CREATE_PLATELIST: '/platelist/create',
  URL_UPDATE_PLATELIST: '/platelist/updateMetadata',
  URL_MANAGE_PLATELIST_DISH: '/platelist/dish',

  // PROSPECT
  URL_GET_ALL_PROSPECTS: '/prospect',
  URL_GET_PROSPECT: '/prospect/:prospectID',
  URL_GET_PROSPECT_SHAPE: '/prospect/shape',
  URL_UPDATE_PROSPECT: '/prospect/:prospectID',
  URL_CONTACT_PROSPECTS: '/prospect/contact',
  URL_VERIFY_PROSPECTS: '/prospect/verify',
  URL_CREATE_PROSPECTS: '/prospect',
  URL_DELETE_PROSPECT: '/prospect/:prospectID',
  URL_CONVERT_PROSPECTS: '/prospect/:prospectID/convert',

  // RECIPE
  URL_GET_ALL_RECIPES: '/recipe/manageRecipes',
  URL_GET_RECIPE: '/recipe/:recipeID/details',
  URL_GET_RECIPE_FILTER_OPTS: '/recipe/getRecipeSearchOptions',
  URL_CREATE_UPDATE_RECIPE: '/recipe/:recipeID/update',
  URL_UPDATE_RECIPE_NUTRITION_UNITS: '/recipe/:recipeID/updateNutrition',

  // TRAINER
  URL_GET_TRAINER_SHAPE: '/trainer/shape?org_id=:orgID',
  URL_GET_ALL_TRAINERS: '/trainer?org_id=:orgID',
  URL_GET_TRAINER: '/trainer/:trainerID?org_id=:orgID',
  URL_CREATE_TRAINER: '/trainer?org_id=:orgID',
  URL_CREATE_TRAINER_SELF: '/trainer/signup?org_id=:orgID',
  URL_UPDATE_TRAINER: '/trainer/:trainerID?org_id=:orgID',
  URL_TRAINER_CHECKOUT: '/trainer/:trainerID/checkout',
  URL_TRAINER_CHECK_COUPON: '/trainer/coupon?coupon=:coupon',
  URL_TRAINER_ADD_PRODUCT_PRICE: '/trainer/:trainerID/product/:productID/price',
  URL_TRAINER_DELETE_PRODUCT_PRICE:
    '/trainer/:trainerID/product/:productID/price/:priceID',
  URL_TRAINER_ADD_COUPON: '/trainer/:trainerID/coupon',
  URL_TRAINER_DELETE_COUPON: '/trainer/:trainerID/coupon/:couponID',
  URL_TRAINER_CANCEL_SUBSCRIPTION:
    '/trainer/:trainerID/subscription/:subscriptionID/cancel',
  URL_TRAINER_ADD_CARD: '/trainer/:trainerID/addCard',
  URL_UPDATE_TRAINER_CLIENT_FEEDBACK:
    '/trainer/:trainerID/client/:clientID/:checkInID/comment',

  // WORKOUT
  URL_GET_WORKOUT_SHAPE:
    '/workout/shape?trainer_id=:trainerID&org_id=:orgID&user_id=:userID',
  URL_GET_ALL_WORKOUTS:
    '/workout?trainer_id=:trainerID&org_id=:orgID&user_id=:userID&page=:page',
  URL_GET_WORKOUT:
    '/workout/:workoutID?trainer_id=:trainerID&org_id=:orgID&user_id=:userID',
  URL_CREATE_WORKOUT:
    '/workout?trainer_id=:trainerID&org_id=:orgID&user_id=:userID',
  URL_UPDATE_WORKOUT:
    '/workout/:workoutID?trainer_id=:trainerID&org_id=:orgID&user_id=:userID',
  URL_DELETE_WORKOUT:
    '/workout/:workoutID?trainer_id=:trainerID&org_id=:orgID&user_id=:userID',

  // FITNESS_TYPE
  URL_GET_ALL_FITNESS_TYPES: '/api/admin/fitnessTypes?org_id=:orgID',
  URL_GET_FITNESS_TYPE: '/api/admin/fitnessTypes/:fitnessTypeID?org_id=:orgID',
  URL_CREATE_FITNESS_TYPE: '/api/admin/fitnessTypes?org_id=:orgID',
  URL_UPDATE_FITNESS_TYPE:
    '/api/admin/fitnessTypes/:fitnessTypeID?org_id=:orgID',
  URL_DELETE_FITNESS_TYPE:
    '/api/admin/fitnessTypes/:fitnessTypeID?org_id=:orgID',
};
